"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _AnimatedLoader = _interopRequireDefault(require("./AnimatedLoader"));

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Loading = function Loading(_ref) {
  var classes = _ref.classes,
      align = _ref.align,
      text = _ref.text,
      position = _ref.position;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.loadingContainer,
    style: {
      alignItems: align,
      position: position ? "unset" : "absolute"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.textContainer
  }, text ? /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true
  }, text) : /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true
  }, "Loading..."), /*#__PURE__*/_react["default"].createElement(_AnimatedLoader["default"], null)));
};

Loading.propTypes = {
  classes: _propTypes["default"].object,
  align: _propTypes["default"].string,
  margin: _propTypes["default"].string,
  minHeight: _propTypes["default"].number,
  text: _propTypes["default"].string
};
Loading.defaultProps = {
  classes: {},
  align: "center"
};

var _default = (0, _styles.withStyles)(_styles2["default"])(Loading);

exports["default"] = _default;